import React, {Component} from 'react';

export default class Option extends Component {

  constructor(props) {
    super(props);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleDeleteOption = this.handleDeleteOption.bind(this);
  }

  handleValueChange(e) {
    this.props.changeOptionValue(
      this.props.customisationIndex,
      this.props.option.index,
      e.target.value,
    );
  }

  handlePriceChange(e) {
    this.props.changeOptionPrice(
      this.props.customisationIndex,
      this.props.option.index,
      e.target.value,
    );
  }

  handleDeleteOption() {
    this.props.deleteDropDownOption(
      this.props.customisationIndex,
      this.props.option.index,
    );
  }

  renderPrice() {
    return (
      this.props.option.index > 0 ?
        <input
          className="Option__price"
          value={this.props.option.price}
          onChange={this.handlePriceChange}
          placeholder="Price, eg. '1.99'"
        /> :
        null
    );
  }

  renderDelete() {
    return (
      this.props.option.index > 1 ?
        <button
          className="Option__delete del"
          onClick={(e) => {
            if (window.confirm('Are you sure you want to delete this option?')) {
              this.handleDeleteOption(e);
            }
          }}
        >&times;</button> :
        null
    );
  }

  render() {
    return (
      <section className="Option">
        <input
          className="Option__value"
          value={this.props.option.value}
          onChange={this.handleValueChange}
          placeholder="Value, eg. 'Green and yellow'"
        />
        {this.renderPrice()}
        {this.renderDelete()}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/item-customisations/fields/drop-down/option.js